import Icon from '../components/Icon.vue'

Icon.register({
  'grin-tongue-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M344 184c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM248 8c137 0 248 111 248 248 0 106.3-67 196.7-161 232 5.6-12.2 9-25.7 9-40v-45.5c24.7-16.2 43.5-38.1 47.8-63.8 1.9-11.8-9.2-21.6-20.7-17.9-30.2 9.7-75.1 15.2-123.1 15.2s-92.9-5.5-123.1-15.2c-11.4-3.6-22.7 6.1-20.7 17.9 4.3 25.7 23.1 47.6 47.8 63.8v45.5c0 14.3 3.4 27.8 9 40-94-35.3-161-125.7-161-232 0-137 111-248 248-248zM192 233c8.4 7.4 21.6 0.3 20-10.8-4-25.2-34.2-42.1-59.9-42.1-25.7 0-55.9 16.9-59.9 42.1-1.8 11.1 11.3 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM344 272c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zM293.1 374.6c0.8 0.4-0.5-0.3 19 9.3v64c0 35.6-29.2 64.5-64.9 64-35.1-0.4-63.1-29.7-63.1-64.9v-63c19.2-9.6 18-9 18.9-9.4 14.4-6.5 31.1 2.2 34.6 17.6l1.8 7.8c2.1 9.2 15.2 9.2 17.3 0l1.8-7.8c3.5-15.4 20.2-24.1 34.6-17.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-tongue-wink.js
// module id = 1408
// module chunks = 0